import styled from 'styled-components';

/**
 * Holds the row's expand chevron.
 *
 * The chevron is authored with a 2px stroke inside a 16px viewBox, so drawing it at the 24px
 * Figma asks for scales the stroke to 3px and it reads as heavy. `non-scaling-stroke` keeps the
 * authored weight whatever the box is scaled to.
 */
export const ChevronSlot = styled.span`
	display: inline-flex;

	& [stroke-width] {
		/* Pinned rather than scaled: the artwork is authored at 2px in a 16px viewBox, so at 24px
		   the stroke would otherwise render at 3px. 1.5px is the weight this size of line icon
		   carries elsewhere. */
		vector-effect: non-scaling-stroke;
		stroke-width: 1.5;
	}
`;
